import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import {
  faPenToSquare,
  faSave,
  faCheck,
  faXmark,
  faFileLines,
  faLanguage
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/Modal";
import CountryTranslation from "./CountryTranslation";
import SearchTable from "../../../components/SearchTable";

const EditableTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields, // New prop for editable fields
  handleLog,
  optionList,
  languageList,
  filteredRows,
  editable

}) => {

  const [transDis, setTransDis] = useState(false);
  const [transData,setTransData] = useState({})
  const handleTranslation = (data,id)=>{
    setTransData({data,id});
    setTransDis(true);
  }

  return (
    <>
    <div className="tableContainer">
     <table className="table text-xs w-[88vw]" role="table">
     <thead className="stickyHeader bg-[var(--mainCol)] text-white">
        <tr>
          {headers?.map((header, index) => (
            <th className="p-1 text-left border" key={index}>
              {header.toUpperCase()}
            </th>
          ))}
          {editable && <th className="p-1 text-left border">ACTION</th>}
        </tr>
      </thead>
      <tbody>
        {filteredRows?.map((row) => (
          <tr key={row.id}>
            {headers.map((header) => (
              <td
                key={header}
                style={{
                  padding: "12px",
                  border: "1px solid #ddd",
                  textAlign: "left",
                }}
              >
                {editRowId === row.id && editableFields.includes(header) ? (
                  header === "optionType" ? (
                    <select
                      value={editedData[header] || ""}
                      onChange={(e) => handleChange(e, header)}
                      style={{
                        width: "100%",
                        padding: "6px",
                        boxSizing: "border-box",
                        border: "1px solid",
                        color: "black",
                      }}
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      {optionList?.result?.map((option, i) => (
                        <option key={i} value={option.title}>
                          {option.title}
                        </option>
                      ))}
                    </select>
                  ) : ["active", "status"].includes(header) ? (
                    <div className="cursor-pointer flex justify-center">
                      {editedData[header] === true && (
                        <FontAwesomeIcon
                          onClick={(e) => handleChange(e, header, true)}
                          value={true}
                          color="var(--green_Main)"
                          icon={faCheck}
                        />
                      )}
                      {editedData[header] === false && (
                        <FontAwesomeIcon
                          onClick={(e) => handleChange(e, header, false)}
                          color="indianred"
                          icon={faXmark}
                        />
                      )}
                    </div>
                  ) : (
                    <input
                      type="text"
                      value={editedData[header] || ""}
                      onChange={(e) => handleChange(e, header)}
                      onKeyUp={(e) => e.key === "Enter" && handleSave()}
                      style={{
                        width: "100%",
                        padding: "6px",
                        boxSizing: "border-box",
                        border: "1px solid",
                        color: "black",
                      }}
                    />
                  )
                ) : header === "translate" && typeof row[header] === "object" ? (
                  <div className="cursor-pointer flex items-center" onClick={()=>handleTranslation(row[header],row.id)}>
                   
                    View Translations
                    <FontAwesomeIcon className="ml-2" icon={faLanguage} />
                  </div>

                ) : row[header] === true ? (
                  <FontAwesomeIcon
                    className="ml-2"
                    color="var(--green_Main)"
                    icon={faCheck}
                  />
                ) : row[header] === false ? (
                  <FontAwesomeIcon
                    className="ml-2"
                    color="indianred"
                    icon={faXmark}
                  />
                ) : (
                  String(row[header])
                )}
              </td>
            ))}
            {editable &&  <td style={{ border: "1px solid #ddd" }}>
              {editRowId === row.id ? (
                <div className="flex justify-center">
                  <FontAwesomeIcon
                    className="p-2 cursor-pointer"
                    color="#67a97b"
                    onClick={handleSave}
                    icon={faSave}
                  />
                  <FontAwesomeIcon
                    className="p-2 cursor-pointer"
                    color="indianred"
                    onClick={handleCancel}
                    icon={faXmark}
                  />
                </div>
              ) : (
                <div className="flex justify-center">
                  <FontAwesomeIcon
                    className="cursor-pointer"
                    onClick={() => handleEdit(row.id)}
                    icon={faPenToSquare}
                  />
                  <FontAwesomeIcon
                    className="ml-2 cursor-pointer"
                    onClick={() => handleLog(row.id)}
                    icon={faFileLines}
                  />
                </div>
              )}
            </td>} 
           
          </tr>
        ))}
      </tbody>
    </table>
    </div>


    

    <Modal
        isOpen={transDis}
        onClose={()=>setTransDis(false)}
        title="Country Translations"
        content={<CountryTranslation currLang={transData} langList={languageList} editable={editable} />}
    />


    </>
   
  );
};

export default EditableTable;